// 浮動通知三檔（SPEC UX-14 ①、NOTIF-02 ①，VMS UX 評審 2026-10-13 P0-1）：只有警報（建議）／警報與偵測／都不跳。
// 是這台電腦的設定（存瀏覽器）；只決定跳不跳，收件匣（鈴鐺）照常。
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { saveToastLevel, savedToastLevel, TOAST_LEVELS, type ToastLevel } from '../../lib/notifications';

export function ToastPrefs() {
  const { t } = useTranslation();
  const [level, setLevel] = useState<ToastLevel>(savedToastLevel);
  return (
    <fieldset className="toast-prefs" data-testid="toast-prefs">
      <legend>{t('toastpref.title')}</legend>
      <p className="muted small">{t('toastpref.help')}</p>
      {TOAST_LEVELS.map((l) => (
        <label key={l} className="check">
          <input
            type="radio"
            name="toast-level"
            value={l}
            checked={level === l}
            onChange={() => {
              setLevel(l);
              saveToastLevel(l);
            }}
          />
          <span>
            {t('toastpref.' + l)}
            <span className="muted small"> — {t('toastpref.' + l + '_help')}</span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
